import React from "react";

import { CheckboxProps, Checkbox as MuiCheckbox } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { checkboxClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import { cssAttributeValue, IStyles } from "../../../util/cssAttributeValue";

const checkBoxTick = require("Assets/icons/tick-checkbox.svg");

export const StyledCheckbox = withStyles({
  [`${checkboxClasses.root}`]: {
    border: "0",
    borderRadius: "4px",
  },
  [`${checkboxClasses.disabled}`]: {
    border: `1.5px solid ${colors.gray800}`,
  },
})((props: CheckboxProps) => <MuiCheckbox color="primary" {...props} />);

export const CheckboxWrapper = styled("div")(() => ({
  display: "flex",
  gap: 16,
}));

interface ICheckboxLabel {
  disabled?: boolean;
}

export const CheckboxLabel = styled("span", {
  shouldForwardProp(propName) {
    return propName !== "disabled";
  },
})(({ disabled }: ICheckboxLabel) => ({
  color: disabled ? colors.gray400 : colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.25px",
}));

export const ContainerTooltipWithLabel = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
  alignItems: "center",
});

export const IconInfoStyle = styled("div")(() => ({
  borderRadius: "100px",
  display: "flex",
  alignItems: "top",
  justifyContent: "center",
}));

const useStyles = makeStyles({
  root: {
    padding: "0px",
    position: "relative",
    "&$checked": {
      border: 0,
      // Aware of the use of the variable, we change it when we use the new kit design
      color: colors.brandBlue500,
    },
    "&$disabled": {
      color: `${colors.gray400} !important`,
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  disabled: {},
  checked: {},
  icon: {
    border: (props: IStyles) =>
      `2px solid ${cssAttributeValue({
        defaultValue: colors.gray500,
        disabled: props.disabled,
        error: props.error,
      })}`,
    borderRadius: 4,
    width: 18,
    height: 18,
    opacity: (props: IStyles) => (props.disabled ? 0.38 : 1),
  },
  checkedIcon: {
    backgroundColor: (props: IStyles) =>
      cssAttributeValue({ disabled: props.disabled, defaultValue: colors.brandBlue500 }),
    opacity: (props: IStyles) => (props.disabled ? 0.38 : 1),
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    borderRadius: "4px", // Ensure rounded checkbox
    width: 18,
    height: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&:before": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      backgroundImage: `url(${checkBoxTick})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "12px 12px", // Adjust icon size for proper alignment
      content: '""',
    },

    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
  controlLabel: {
    alignItems: "center",
    display: "flex",
    gap: 16,
    margin: 0,
  },
});

export default useStyles;
